// or (a, b) => a - b;
export const alphabeticalSort = (a, b) => {
	if (a < b)
		return -1;
	if (b < a)
		return 1;

	return 0;
};
